export const ROLL_DICE = "ROLL_DICE";

export const HOLD_SCORE = "HOLD_SCORE";

export const NEW_GAME = "NEW_GAME";
